<template>
  <div>
    <div class="lke-titl">
      <i class="el-icon-caret-right"></i>
      当前位置：培训须知
    </div>
    <el-tabs v-model="activeName" type="card" v-loading="loading">
      <el-tab-pane label="培训须知" name="first">
        <div class="lke-list" v-html="peixunHtml"></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { gethomeinfo } from "@/api/index";
export default {
  props: {},
  data() {
    return {
      activeName: "first",
      loading: false,
      peixunHtml: "",
    };
  },
  computed: {},
  created() {
    this.gethomeinfo();
  },
  mounted() {},
  watch: {},
  methods: {
    gethomeinfo() {
      this.loading = true;
      gethomeinfo().then((response) => {
        this.peixunHtml = response.system.peixunHtml;
        this.loading = false;
      });
    },
    openRouter(val) {
      this.$router.push({ name: val });
    },
  },
  components: {},
};
</script>

<style>
</style>

<style scoped>
.lke-titl {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-bottom: 20px;
}
.lke-titl > i {
  color: #2890f4;
  padding-right: 5px;
  font-size: 20px;
}
.lke-list {
  color: #666666;
  padding: 30px 20px;
}
.lke-list p {
  font-size: 16px;
  line-height: 2;
  text-indent: 30px !important;
}
.lke-list span {
  line-height: 2;
  font-family: 仿宋_GB2312;
  font-size: 12pt;
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/pxxz/pxxz.vue